import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { BasicButton } from 'components';
import { useCallback } from 'react';
import classes from './index.module.css';

interface IDialog {
  btnText: string,
  btnVariant?: string
  children: React.ReactNode;
  isOpened?: boolean;
  onClose?: () => void;
  title?: string,
}

const Dialog = ({ btnText, btnVariant, children, isOpened, onClose, title }: IDialog) => {
  const [opened, { open, close }] = useDisclosure(isOpened);

  const onCloseWrapper = useCallback(() => {
    if (onClose) {
      onClose();
    }
    close();
  }, [onClose]);

  return (
    <>
      <Modal.Root opened={opened} size='lg' onClose={onCloseWrapper} className={classes.modal} centered>
        <Modal.Overlay />
        <Modal.Content className={classes.content}>
          <Modal.Header>
            <Modal.Title className={classes.title}>{title}</Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body pt={20}>
            {children}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
      <BasicButton variant={btnVariant} onClick={open}>{btnText}</BasicButton>
    </>
  )
}

export default Dialog;